import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { CompleteImages } from '../../../../_global/fragments/generated/CompleteImages';
import { WorkspaceGridProject } from '../../fragments/generated/WorkspaceGridProject';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetWorkspaceProjectsQueryVariables = Types.Exact<{
  workspaceId: Types.Scalars['ID']['input'];
  page: Types.PageInput;
  projectStatusFilters?: Types.InputMaybe<Array<Types.ProjectStatusInput>>;
  orders?: Types.InputMaybe<Array<Types.ProjectOrderInput>>;
  query?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetWorkspaceProjectsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, workspace?: { __typename?: 'Workspace', id: string, access?: Types.AccessEnum | null, accountId?: string | null, collaboratorCount?: number | null, name: string, projectCount?: number | null, images?: { __typename?: 'Images', image32?: string | null, image64?: string | null, image128?: string | null, image256?: string | null, imageBase?: string | null, original?: string | null } | null, permissions?: { __typename?: 'WorkspacePermissions', canDelete: boolean } | null, projects?: { __typename?: 'ProjectConnection', totalCount: number, nodes: Array<{ __typename?: 'Project', adobeAssetId?: string | null, archivedAt?: string | null, deletedAt?: string | null, description?: string | null, fileCount: number, id: string, isLoading?: boolean | null, name: string, rootAssetId: string, private: boolean, storage: number, updatedAt?: string | null, ignoreArchive: boolean, notificationsEnabled?: boolean | null, images: { __typename?: 'Images', image32?: string | null, image256?: string | null, imageBase?: string | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null } | null } | null };


export const GetWorkspaceProjects = /*#__PURE__*/ gql`
    query GetWorkspaceProjects($workspaceId: ID!, $page: PageInput!, $projectStatusFilters: [ProjectStatusInput!], $orders: [ProjectOrderInput!], $query: String) {
  account(by: {workspaceId: $workspaceId}) {
    id
    workspace(workspaceId: $workspaceId) {
      id
      access
      accountId
      collaboratorCount
      images {
        ...CompleteImages
      }
      name
      projectCount
      permissions {
        canDelete
      }
      projects(
        page: $page
        filter: {projectStatus: $projectStatusFilters, query: $query}
        orders: $orders
      ) {
        nodes {
          ...WorkspaceGridProject
        }
        pageInfo {
          endCursor
          hasNextPage
        }
        totalCount
      }
    }
  }
}
    ${CompleteImages}
${WorkspaceGridProject}` as unknown as DocumentNode<GetWorkspaceProjectsQuery, GetWorkspaceProjectsQueryVariables>;

          

          export const useGetWorkspaceProjectsQuery = (options?:QueryHookOptions<GetWorkspaceProjectsQuery, GetWorkspaceProjectsQueryVariables>) => useQuery(GetWorkspaceProjects, options);

          

          export type GetWorkspaceProjectsQueryOptions = QueryHookOptions<GetWorkspaceProjectsQuery, GetWorkspaceProjectsQueryVariables>;

          

          export const useGetWorkspaceProjectsLazyQuery = (options?:LazyQueryHookOptions<GetWorkspaceProjectsQuery, GetWorkspaceProjectsQueryVariables>) => useLazyQuery(GetWorkspaceProjects, options);

          

          export type GetWorkspaceProjectsQueryResult = ReturnType<typeof useGetWorkspaceProjectsQuery>;

          
